var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.424 3.106a2.065 2.065 0 1 0-4.128-.083l-.344 16.998v.043c0 .85-.106 1.882-.377 2.832-.277.97-.678 1.683-1.147 2.106-1.22 1.106-2.32 1.65-3.584 1.744l-.51.039c-1.43.108-1.788.135-2.985-.026-3.016-.406-5.199-2.076-5.868-4.324-.376-1.26-.426-2.854-.269-4.407.158-1.555.501-2.843.747-3.431.151-.364.602-.93 1.323-1.515.706-.574 1.383-.935 1.69-1.037 1.01-.337 1.72-.543 2.83-.627l-1.13 1.472A2.065 2.065 0 0 0 16.95 15.4l3.854-5.023.985-1.283-1.012-1.263-3.854-4.816a2.065 2.065 0 1 0-3.224 2.58l1.339 1.673c-1.89.083-3.048.417-4.372.859-.932.31-2.044.982-2.99 1.75-.93.756-1.993 1.842-2.53 3.13-.443 1.063-.857 2.77-1.043 4.603-.186 1.837-.169 4.028.42 6.002 1.257 4.221 5.13 6.68 9.273 7.237 1.634.22 2.362.164 3.846.05l.505-.038c2.45-.181 4.38-1.288 6.049-2.799 1.25-1.133 1.951-2.656 2.345-4.033.397-1.388.534-2.804.535-3.945l.344-16.979z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/DOCK.bdb91ab6ffb9b1ceee706f0863d97185.svg";
export { ForwardRef as ReactComponent };